import React, { Component, useState } from 'react'
import { useHistory } from 'react-router';
import { setUserSession, useFormInput } from '../utils';
import { login } from '../utils/Network';
import './Signin.css'



export default function SignIn() {

    const username = useFormInput('');
    const password = useFormInput('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const handleLogin = () => {

        setError(null);
        setLoading(true);

        if (username.value.length < 3) {
            setError('username is not valid');
            setLoading(false);
            return;
        }

        if (password.value.length < 6) {
            setError('Password is not valid');
            setLoading(false);
            return;
        }

        login({ email: username.value, password: password.value }).then(function (data) {
            console.log(data)
            if (data.tokens) {
                if (data.role === "admin" || data.role === "editor") {
                  setUserSession(data.tokens.access, data);
                  window.location.href = "/cms/dashboard";
                } else setError("Access Denied.");
                
            }
            else {
                setError(data.detail);
            }
            setLoading(false)

        });

    }
    return (
        
        <div className="login-box">
            <div className="login-logo">
                <a href=""><b>CJIT</b>ADMIN</a>
            </div>
            
            <div className="login-box-body">
                <form action="" method="post">
                    <div className="form-group has-feedback mb-10">
                        <input {...username} type="username" className="form-control signin-control" placeholder="Email" />
                        <span className="glyphicon glyphicon-envelope form-control-feedback"></span>
                    </div>
                    <div className="form-group has-feedback mb-10">
                        <input {...password} type="password" className="form-control signin-control" placeholder="Password" />
                        <span className="glyphicon glyphicon-lock form-control-feedback"></span>
                    </div>
                    <div className="row">
                        <div className="col-xs-6 form-checkbox mb-10">
                            <div className=" icheck">
                                <label>
                                    <input type="checkbox" /> Remember Me
                                </label>
                            </div>
                        </div>

                        <div className="col-xs-6 text-right pull-right">
                            <a href="" className="signin">Forgot password</a>
                        </div>

                        <div className="col-xs-12">
                            <button type="submit" onClick={handleLogin} disabled={loading} className="btn btn-primary btn-rounded btn-block"><i className="fa fa-user"></i> Login</button>
                        </div>

                    </div>
                </form>
                {loading && <><small style={{ color: 'green' }}>Please Wait...</small><br /><br /></>}


                {error && <>
                    <br />
                    <div className="alert alert-danger">
                        {error}
                    </div>
                </>}

            </div>
        </div>
    )

}
